import React from 'react';
import { useParams } from 'react-router-dom';
import { useTransfer } from '../../hooks/useTransfers';
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  CardFooter,
  Skeleton,
  Button
} from '@tonic/shared/components/ui';

export function TransferDetail() {
  const { id } = useParams();
  const { transfer, isLoading } = useTransfer(id);

  const handleApprove = () => {
    // TODO: Implement approval logic
    console.log('Approving transfer:', id);
  };

  const handleReject = () => {
    // TODO: Implement rejection logic
    console.log('Rejecting transfer:', id);
  };

  if (isLoading) {
    return (
      <div className="container mx-auto py-6">
        <Skeleton className="h-8 w-48 mb-6" />
        <div className="grid gap-6">
          <Card>
            <CardHeader>
              <Skeleton className="h-6 w-36" />
            </CardHeader>
            <CardContent>
              <div className="grid grid-cols-2 gap-4">
                {[...Array(5)].map((_, index) => (
                  <div key={index}>
                    <Skeleton className="h-4 w-24 mb-2" />
                    <Skeleton className="h-4 w-32" />
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <Skeleton className="h-6 w-24" />
            </CardHeader>
            <CardContent>
              <div className="space-y-4">
                {[...Array(2)].map((_, index) => (
                  <div key={index} className="flex justify-between">
                    <Skeleton className="h-4 w-32" />
                    <Skeleton className="h-4 w-16" />
                  </div>
                ))}
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    );
  }

  if (!transfer) {
    return (
      <div className="container mx-auto py-6">
        <h1 className="text-2xl font-bold mb-6">Transfer Not Found</h1>
      </div>
    );
  }

  return (
    <div className="container mx-auto py-6">
      <h1 className="text-2xl font-bold mb-6">Transfer Details</h1>

      <div className="grid gap-6">
        <Card>
          <CardHeader>
            <CardTitle>Transfer Information</CardTitle>
          </CardHeader>
          <CardContent>
            <dl className="grid grid-cols-2 gap-4">
              <div>
                <dt className="text-sm font-medium text-gray-500">Transfer ID</dt>
                <dd className="mt-1 text-sm text-gray-900">{transfer.id}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">Status</dt>
                <dd className="mt-1 text-sm text-gray-900">{transfer.status}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">Source Location</dt>
                <dd className="mt-1 text-sm text-gray-900">{transfer.sourceLocation}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">Destination Location</dt>
                <dd className="mt-1 text-sm text-gray-900">{transfer.destinationLocation}</dd>
              </div>
              <div>
                <dt className="text-sm font-medium text-gray-500">Created At</dt>
                <dd className="mt-1 text-sm text-gray-900">
                  {new Date(transfer.createdAt).toLocaleString()}
                </dd>
              </div>
            </dl>
          </CardContent>
        </Card>

        <Card>
          <CardHeader>
            <CardTitle>Items</CardTitle>
          </CardHeader>
          <CardContent>
            <table className="min-w-full divide-y divide-gray-200">
              <thead>
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Item Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                    Quantity
                  </th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-200">
                {transfer.items.map((item) => (
                  <tr key={item.id}>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {item.name}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                      {item.quantity}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </CardContent>
          <CardFooter className="flex justify-end space-x-4">
            <Button variant="outline" onClick={handleReject}>
              Reject Transfer
            </Button>
            <Button onClick={handleApprove}>Approve Transfer</Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}

TransferDetail.propTypes = {}; 
